<template>
    <vs-row vs-justify="center">
      <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
        <vs-card>
          <div class="d-md-flex align-items-center pb-2">
            <h3 class="card-title mb-0">{{ formdata.isEdit ? 'Edit Transaksi Bank Masuk' : 'Transaksi Bank Masuk' }}</h3>
            <div class="ml-auto">
              <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
                Batal
              </vs-button>
            </div>
          </div>
          <vs-alert v-if="errors.length" class="mb-3 mt-2" color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </vs-alert>
          <div>
            <vs-row>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
                  <label class="vs-input--label">Tanggal</label>
                  <div class="vs-con-input">
                    <date-picker
                      v-model="formdata.trans_tgl"
                      format="DD-MM-YYYY"
                      value-type="format"
                      placeholder="Pilih Tgl" input-class="vs-input--input"
                      :disabled-date="disabledBeforeYear">
                    </date-picker>
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
                <vs-select class="w-100 mt-4" autocomplete label="Penerimaan lewat" v-model="formdata.bank_id">
                  <vs-select-item
                    v-for="(opt, i) in pembayaranOptions"
                    :key="i"
                    :value="opt.kode_perk"
                    :text="opt.kode_perk + ' - ' + opt.nama_perk"
                  />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-row class="mt-3">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <label class="vs-input--label d-block mb-2">Mode Penerimaan</label>
                <div class="d-flex align-items-center">
                  <vs-radio v-model="payMode" vs-value="manual" class="mr-4">Manual (Rincian Perkiraan)</vs-radio>
                  <vs-radio v-model="payMode" vs-value="ar">Account Receivable</vs-radio>
                </div>
              </vs-col>
            </vs-row>

            <vs-row v-if="payMode === 'ar'" class="mt-2">
              <vs-col vs-lg="7" vs-xs="12" vs-sm="8">
                <vs-select class="w-100 mt-4" autocomplete label="Pilih Account Receivable (belum lunas)" v-model="selectedArId">
                  <vs-select-item
                    v-for="(ar, i) in arOptions"
                    :key="i"
                    :value="ar.id"
                    :text="ar.display"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" v-if="selectedArId">
                <vs-input label="Sisa Piutang" class="w-100 mt-4" :value="selectedArSisaFormatted" disabled />
              </vs-col>
            </vs-row>

            <vs-row v-if="payMode === 'manual'" class="mt-2">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <h5 class="mb-2">Rincian Perkiraan</h5>
                <div v-for="(row, idx) in perkRows" :key="idx" class="mb-2 p-2 border-bottom">
                  <vs-row>
                    <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                      <vs-select class="w-100 mt-4" autocomplete label="Kode Perkiraan" v-model="row.kode_perk" @change="onPerkChange(row)">
                        <vs-select-item
                          v-for="(opt, i) in perkOptions"
                          :key="i"
                          :value="opt.kode_perk"
                          :text="opt.kode_perk + ' - ' + (opt.nama_perk || opt.nama)"
                        />
                      </vs-select>
                    </vs-col>
                    <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                      <vs-input label="Nama Perkiraan" class="w-100 mt-4" v-model="row.nama_perk" readonly />
                    </vs-col>
                    <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
                      <vs-input label="Nilai" class="w-100 mt-4" v-model="row.nilai" v-currency="options"/>
                    </vs-col>
                    <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                      <vs-input label="Keterangan" class="w-100 mt-4" v-model="row.keterangan"/>
                    </vs-col>
                    <vs-col vs-lg="1" vs-xs="12" vs-sm="2">
                      <div class="mt-5">
                        <vs-button color="danger" icon="remove" type="flat" @click="removeRow(idx)" v-if="perkRows.length > 1"></vs-button>
                      </div>
                    </vs-col>
                  </vs-row>
                </div>
                <vs-button color="primary" icon="add" type="gradient" @click="addRow">Tambah Baris</vs-button>
              </vs-col>
            </vs-row>
          </div>
          <br/>
          <div class="btn-alignment mt-4">
            <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
            <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input'

export default {
  components: {
    DatePicker
  },
  directives: {
    currency: CurrencyDirective
  },
  data: function () {
    return {
      locale: 'us',
      currency: null,
      payMode: 'manual',
      pembayaranOptions: [],
      perkOptions: [],
      arOptions: [],
      selectedArId: null,
      formdata: {
        trans_tgl: '',
        bank_id: '',
        keterangan: '',
        trans_jumlah: 0,
        isEdit: false,
        prevReferensi: this.$route.params.ref || null,
        opr: '-'
      },
      perkRows: [
        { kode_perk: '', nama_perk: '', nilai: 0, keterangan: '' }
      ],
      errors: [],
      inputUrl: '/api/bankin'
    }
  },
  methods: {
    backpage: function () {
      this.$router.go(-1);
    },
    disabledBeforeYear(date) {
      return date.getFullYear() < window.$cookies.get('THN') || date.getFullYear() > window.$cookies.get('THN');
    },
    fetchPembayaranOptions: function () {
      this.$http.get('/api/perkwithsub/1').then(resp => {
        const data = resp && resp.data ? resp.data : []
        const list = Array.isArray(data)
          ? data
          : (data && Array.isArray(data.subperkiraan) ? data.subperkiraan : [])
        this.pembayaranOptions = list.map(it => ({
          kode_perk: it.kode_perk,
          nama_perk: it.nama_perk
        }))
      }).catch(() => {
        this.pembayaranOptions = []
      })
    },
    fetchPerkOptions: function () {
      this.$http.get('/api/perklist').then(resp => {
        this.perkOptions = resp.data || []
      }).catch(() => {
        this.perkOptions = []
      })
    },
    fetchAccountReceivable: function (selectedId = null) {
      this.$http.post('/api/arlist', { filter: 'blm lunas' }).then(resp => {
        let arr = Array.isArray(resp.data) ? resp.data : []
        if (selectedId && !arr.find(a => a.id == selectedId)) {
          this.$http.get('/api/accountreceivable/' + selectedId).then(resSingle => {
            if (resSingle.data) {
              arr.unshift(resSingle.data);
            }
            this.populateArOptions(arr);
          }).catch(() => {
            this.populateArOptions(arr);
          });
        } else {
          this.populateArOptions(arr);
        }
      }).catch(() => {
        this.arOptions = []
      })
    },
    populateArOptions: function (arr) {
      this.arOptions = arr.map(ar => ({
        id: ar.id,
        no_ar: ar.no_ar,
        nama_customer: ar.nama_customer || '-',
        no_referensi: ar.no_referensi || '',
        total_nilai: Number(ar.total_nilai || 0),
        sisa_piutang: Number(ar.sisa_piutang || 0),
        display: `${ar.no_ar} | ${ar.nama_customer || '-'} | Ref: ${ar.no_referensi || '-'} | Sisa: ${new Intl.NumberFormat('id-ID', { style: 'decimal', maximumFractionDigits: 0 }).format(Number(ar.sisa_piutang || 0))}`
      }))
    },
    getAllData: function () {
      if (this.$route.params.ref != null) {
        this.formdata.isEdit = true;
        this.formdata.prevReferensi = this.$route.params.ref;
        this.$http.get(this.inputUrl + '/' + this.$route.params.ref).then(response => {
          const d = response.data;
          this.formdata.keterangan = d.keterangan || '';
          this.formdata.bank_id = d.bank_id ? String(d.bank_id) : '';
          const tgl = d.tanggal || d.trans_tgl;
          if (tgl) {
            let parts = tgl.split("-");
            if (parts.length === 3) {
              if (parts[0].length === 4) {
                this.formdata.trans_tgl = `${parts[2]}-${parts[1]}-${parts[0]}`;
              } else {
                this.formdata.trans_tgl = tgl;
              }
            }
          }
          if (Number(d.ar_id) > 0) {
            this.payMode = 'ar';
            this.selectedArId = Number(d.ar_id);
            this.fetchAccountReceivable(this.selectedArId);
          } else {
            this.payMode = 'manual';
            this.selectedArId = null;
            if (d.details && d.details.length > 0) {
              this.perkRows = d.details.map(rd => ({
                kode_perk: rd.kode_perk,
                nama_perk: rd.nama_perk,
                nilai: Number(rd.nilai) || 0,
                keterangan: rd.keterangan || ''
              }));
            }
          }
        }).catch(error => {
          console.log(error);
          this.$vs.notify({ title: 'Error', text: 'Gagal inisiasi data, silahkan coba lagi...', color: 'danger' });
        });
      }
      this.formdata.opr = this.$store.getters.getUserName;
    },
    numberValue(value) {
      const val = value ? value : 0;
      return parseCurrency(val.toString(), this.options)
    },
    onPerkChange(row) {
      const found = this.perkOptions.find(p => p.kode_perk === row.kode_perk);
      if (found) row.nama_perk = found.nama_perk || found.nama || '';
    },
    addRow: function () {
      this.perkRows.push({ kode_perk: '', nama_perk: '', nilai: 0, keterangan: '' })
    },
    removeRow: function (index) {
      this.perkRows.splice(index, 1)
    },
    normalizedPerkRows: function () {
      return this.perkRows
        .filter(r => r && r.kode_perk)
        .map(r => ({
          kode_perk: r.kode_perk,
          nama_perk: r.nama_perk,
          nilai: this.numberValue(r.nilai),
          keterangan: r.keterangan || ''
        }))
    },
    checkForm: function () {
      this.errors = []
      if (!this.formdata.trans_tgl) this.errors.push('Tanggal belum terisi...')
      if (!this.formdata.bank_id) this.errors.push('Penerimaan lewat belum dipilih...')

      let payload = { ...this.formdata }
      payload.opr = this.$store.getters.getUserName

      if (this.payMode === 'ar') {
        if (!this.selectedArId) this.errors.push('Account Receivable belum dipilih...')
        const sel = this.arOptions.find(a => a.id === this.selectedArId)
        payload.ar_id = this.selectedArId
        payload.trans_jumlah = sel ? sel.sisa_piutang : 0
        payload.mode = 'ar'
      } else {
        const rows = this.normalizedPerkRows()
        if (rows.length === 0) this.errors.push('Rincian perkiraan minimal 1 baris...')
        rows.forEach((r, i) => {
          if (!r.kode_perk) this.errors.push(`Baris ${i + 1}: Kode perkiraan belum dipilih...`)
          if (!r.nilai || r.nilai <= 0) this.errors.push(`Baris ${i + 1}: Nilai belum terisi...`)
        })
        payload.perk_rows = rows
        const total = rows.reduce((acc, r) => acc + Number(r.nilai || 0), 0)
        payload.trans_jumlah = total
        payload.mode = 'manual'
      }

      if (this.errors.length > 0) {
        this.$vs.notify({ title: 'Gagal Menyimpan Data', text: 'Periksa inputan anda', color: 'danger' })
        return
      }

      this.$vs.loading({ type: 'radius' })
      this.$http.post(this.inputUrl, { formdata: payload }).then(() => {
        this.$vs.loading.close()
        this.$vs.notify({ title: 'Success', text: 'Data berhasil disimpan..', color: 'success' })
        this.$router.push({ name: 'bankinlist' });
      }).catch((error) => {
        this.$vs.loading.close()
        if (error && error.response && error.response.data && error.response.data.errors) {
          const keys = Object.keys(error.response.data.errors)
          for (const key of keys) this.errors.push(error.response.data.errors[key][0])
        } else {
          this.errors.push('Terjadi error di server..')
        }
      })
    }
  },
  computed: {
    options() {
      return {
        locale: this.locale,
        currency: this.currency
      }
    },
    selectedAr() {
      return this.arOptions.find(a => a.id === this.selectedArId) || null
    },
    selectedArSisa() {
      return this.selectedAr ? this.selectedAr.sisa_piutang : 0
    },
    selectedArSisaFormatted() {
      return new Intl.NumberFormat('id-ID', { style: 'decimal', maximumFractionDigits: 0 }).format(this.selectedArSisa)
    }
  },
  mounted: function () {
    this.getAllData();
    this.fetchPembayaranOptions();
    this.fetchPerkOptions();
    if (!this.$route.params.ref) {
      this.fetchAccountReceivable();
    }
  }
}
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
